import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updatePayment } from "api/payment.api";
import {
  invalidateDashboardSources,
  invalidatePaymentSide,
} from "lib/cacheInvalidation";

export const useUpdatePayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }) => updatePayment(id, body),
    onSuccess: () => {
      invalidatePaymentSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
